import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-celeste/15 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-152" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-153" data-mp="2vppmn6uzk4c8">
        <div className="text-center" data-id="element-154" data-mp="39hw36u21wdc7">
          <SectionHeading id="problem-title" data-id="element-155" data-mp="39gul45mmaqkz">Ti suona <span className="text-celeste" data-id="element-156" data-mp="39jqls1puntd4">familiare?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-mist" data-id="element-157" data-mp="35frbw1z2rssq">
            La meteorologia fa parte del tuo programma, ma trasformarla in lezioni chiare e coinvolgenti richiede tempo.
            Fronti, pressione, nubi e masse d&apos;aria sono concetti che gli studenti faticano a visualizzare, e tu devi
            spiegarli senza materiali adeguati.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-celeste/20 bg-ink/55 p-6 shadow-lg shadow-black/30 backdrop-blur-md sm:p-8" data-id="element-158" data-mp="1k4simaoe408c">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-extrabold uppercase text-white" data-id="element-159" data-mp="x5jtpxo4spwk">
            <AlertTriangleIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-160" data-mp="122tg14g84lg6" />
            Il vero problema:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-161" data-mp="170v1fw14gwut">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-mist" data-id="element-162" data-mp="1c33usthwq0xg">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-celeste shadow-[0_0_10px_rgba(94,200,242,0.6)]" aria-hidden="true" data-id="element-163" data-mp="1g2co5x91bwsh" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-164" data-mp="3hv97e7d3m5no">
          <p className="mx-auto max-w-2xl text-lg font-bold text-white" data-id="element-165" data-mp="p08xdgznoq9s">
            Non ti servono altre informazioni sparse.
          </p>
          <p className="mt-3 text-2xl font-extrabold uppercase tracking-tight text-gold sm:text-3xl" data-id="element-166" data-mp="k2h9qz61nqbe">Ti serve un sistema organizzato e pronto per la classe.</p>
        </div>
      </div>
    </section>;
}